module.exports = __webpack_public_path__ + "media/paid-sound.19700b73.mp3";